import React, { useState, useEffect } from 'react';
import { Tag, Plus, Edit2, Trash2, Grid, List } from 'lucide-react';
import { API_URL } from '../../services/api';

function GestionCategoriesTypes() {
  const [activeTab, setActiveTab] = useState('categories');
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [collections, setCollections] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  
  const [formData, setFormData] = useState({
    nom: '',
    code: '',
    description: '',
    ordre_affichage: 0,
    actif: true
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [categoriesRes, typesRes, collectionsRes] = await Promise.all([
        fetch(`${API_URL}/collections/categories-bijoux`),
        fetch(`${API_URL}/collections/types-bijoux`),
        fetch(`${API_URL}/collections`)
      ]);

      if (categoriesRes.ok) setCategories(await categoriesRes.json());
      if (typesRes.ok) setTypes(await typesRes.json());
      if (collectionsRes.ok) setCollections(await collectionsRes.json());
    } catch (error) {
      console.error('Erreur chargement données:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    let url = '';
    if (activeTab === 'categories') {
      url = editMode
        ? `${API_URL}/collections/categories-bijoux/${currentItem.id}`
        : `${API_URL}/collections/categories-bijoux`;
    } else if (activeTab === 'types') {
      url = editMode
        ? `${API_URL}/collections/types-bijoux/${currentItem.id}`
        : `${API_URL}/collections/types-bijoux`;
    } else {
      url = editMode
        ? `${API_URL}/collections/${currentItem.id}`
        : `${API_URL}/collections`;
    }
    
    try {
      const response = await fetch(url, {
        method: editMode ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert(editMode ? 'Mis à jour avec succès' : 'Créé avec succès');
        setShowModal(false);
        resetForm();
        loadData();
      } else {
        const error = await response.json();
        alert(`Erreur: ${error.error}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'enregistrement');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet élément ?')) return;
    
    let url = '';
    if (activeTab === 'categories') {
      url = `${API_URL}/collections/categories-bijoux/${id}`;
    } else if (activeTab === 'types') {
      url = `${API_URL}/collections/types-bijoux/${id}`;
    } else {
      url = `${API_URL}/collections/${id}`;
    }
    
    try {
      const response = await fetch(url, { method: 'DELETE' });
      if (response.ok) {
        alert('Supprimé avec succès');
        loadData();
      } else {
        const error = await response.json();
        alert(`Erreur: ${error.error}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la suppression');
    }
  };

  const resetForm = () => {
    setFormData({
      nom: '',
      code: '',
      description: '',
      ordre_affichage: 0,
      actif: true,
      photo_url: ''
    });
    setCurrentItem(null);
    setEditMode(false);
  };

  const openEditModal = (item) => {
    setCurrentItem(item);
    setEditMode(true);
    setFormData({
      nom: item.nom,
      code: item.code || '',
      description: item.description || '',
      ordre_affichage: item.ordre_affichage || 0,
      actif: item.actif !== undefined ? item.actif : true,
      photo_url: item.photo_url || ''
    });
    setShowModal(true);
  };

  const openCreateModal = () => {
    resetForm();
    setShowModal(true);
  };

  const renderTable = (data, type) => (
    <div>
      {/* Table desktop */}
      <div className="hidden md:block bg-white rounded-lg shadow-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold">Nom</th>
              {type !== 'types' && <th className="px-4 py-3 text-left text-sm font-semibold">Code</th>}
              <th className="px-4 py-3 text-left text-sm font-semibold">Description</th>
              <th className="px-4 py-3 text-center text-sm font-semibold">Ordre</th>
              <th className="px-4 py-3 text-center text-sm font-semibold">Statut</th>
              <th className="px-4 py-3 text-center text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => (
              <tr key={item.id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-3 font-semibold">{item.nom}</td>
                {type !== 'types' && <td className="px-4 py-3 font-mono text-sm">{item.code}</td>}
                <td className="px-4 py-3 text-sm text-gray-600">{item.description}</td>
                <td className="px-4 py-3 text-center">{item.ordre_affichage}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`px-2 py-1 rounded text-xs font-semibold ${
                    item.actif ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                  }`}>
                    {item.actif ? 'Actif' : 'Inactif'}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <button
                      onClick={() => openEditModal(item)}
                      className="text-blue-600 hover:text-blue-800"
                      title="Modifier"
                    >
                      <Edit2 size={18} />
                    </button>
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="text-red-600 hover:text-red-800"
                      title="Supprimer"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Cards mobile */}
      <div className="md:hidden space-y-3">
        {data.map(item => (
          <div key={item.id} className="bg-white rounded-lg shadow p-4 border-l-4 border-indigo-400">
            <div className="flex justify-between items-start mb-2">
              <div>
                <div className="font-bold text-gray-900">{item.nom}</div>
                {item.code && <div className="text-xs font-mono text-gray-500">{item.code}</div>}
              </div>
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                item.actif ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
              }`}>
                {item.actif ? 'Actif' : 'Inactif'}
              </span>
            </div>
            {item.description && (
              <div className="text-xs text-gray-500 mb-3">{item.description}</div>
            )}
            <div className="flex gap-2 mt-2">
              <button
                onClick={() => openEditModal(item)}
                className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium"
              >
                Modifier
              </button>
              <button
                onClick={() => handleDelete(item.id)}
                className="px-4 py-2 bg-red-100 text-red-700 rounded-lg text-sm font-medium"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Tag className="text-purple-600" />
          Gestion Catégories, Types et Collections
        </h1>
        <p className="text-gray-600 mt-1">
          Gérez les catégories (beldi, bébé, joaillerie), types (bracelet, bague) et collections
        </p>
      </div>

      {/* Onglets */}
      <div className="mb-6 border-b overflow-x-auto">
        <div className="flex gap-1 min-w-max">
          <button
            onClick={() => setActiveTab('categories')}
            className={`px-4 py-2 font-semibold flex items-center gap-2 whitespace-nowrap ${
              activeTab === 'categories'
                ? 'border-b-2 border-purple-600 text-purple-600'
                : 'text-gray-600'
            }`}
          >
            <Grid size={18} />
            Catégories ({categories.length})
          </button>
          <button
            onClick={() => setActiveTab('types')}
            className={`px-4 py-2 font-semibold flex items-center gap-2 whitespace-nowrap ${
              activeTab === 'types'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-600'
            }`}
          >
            <List size={18} />
            Types de Bijoux ({types.length})
          </button>
          <button
            onClick={() => setActiveTab('collections')}
            className={`px-4 py-2 font-semibold flex items-center gap-2 whitespace-nowrap ${
              activeTab === 'collections'
                ? 'border-b-2 border-green-600 text-green-600'
                : 'text-gray-600'
            }`}
          >
            <Tag size={18} />
            Collections ({collections.length})
          </button>
        </div>
      </div>

      {/* Bouton Ajouter */}
      <div className="mb-6">
        <button
          onClick={openCreateModal}
          className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center gap-2"
        >
          <Plus size={20} />
          {activeTab === 'categories' ? 'Nouvelle Catégorie' : 
           activeTab === 'types' ? 'Nouveau Type' : 'Nouvelle Collection'}
        </button>
      </div>

      {/* Contenu des onglets */}
      {activeTab === 'categories' && renderTable(categories, 'categories')}
      {activeTab === 'types' && renderTable(types, 'types')}
      {activeTab === 'collections' && renderTable(collections, 'collections')}

      {/* Modal Création/Édition */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg w-full max-w-md max-h-[95vh] sm:max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-bold mb-4">
                {editMode ? 'Modifier' : 'Créer'} {
                  activeTab === 'categories' ? 'une catégorie' : 
                  activeTab === 'types' ? 'un type' : 'une collection'
                }
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className={`grid gap-4 ${activeTab !== 'types' ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1'}`}>
                  <div>
                    <label className="block text-sm font-medium mb-1">Nom *</label>
                    <input
                      type="text"
                      required
                      value={formData.nom}
                      onChange={(e) => setFormData({...formData, nom: e.target.value})}
                      className="w-full border rounded px-3 py-2"
                      placeholder={
                        activeTab === 'categories' ? 'Ex: Beldi, Bébé, Joaillerie' :
                        activeTab === 'types' ? 'Ex: Bracelet, Gourmette, Bague' :
                        'Ex: Nash, Royal, Prestige'
                      }
                    />
                  </div>

                  {activeTab !== 'types' && (
                    <div>
                      <label className="block text-sm font-medium mb-1">Code</label>
                      <input
                        type="text"
                        value={formData.code}
                        onChange={(e) => setFormData({...formData, code: e.target.value.toUpperCase()})}
                        className="w-full border rounded px-3 py-2"
                        placeholder="Ex: BELDI, NASH (auto si vide)"
                      />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Description</label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    className="w-full border rounded px-3 py-2"
                    rows="3"
                    placeholder="Description..."
                  />
                </div>

                {activeTab === 'collections' && (
                  <div>
                    <label className="block text-sm font-medium mb-1">URL Photo</label>
                    <input
                      type="text"
                      value={formData.photo_url}
                      onChange={(e) => setFormData({...formData, photo_url: e.target.value})}
                      className="w-full border rounded px-3 py-2"
                      placeholder="https://..."
                    />
                  </div>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
                  <div>
                    <label className="block text-sm font-medium mb-1">Ordre d'affichage</label>
                    <input
                      type="text" inputMode="decimal" onFocus={e => e.target.select()}
                      value={formData.ordre_affichage}
                      onChange={(e) => setFormData({...formData, ordre_affichage: parseInt(e.target.value)})}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div className="flex items-center gap-2 pb-2">
                    <input
                      type="checkbox"
                      id="actif"
                      checked={formData.actif}
                      onChange={(e) => setFormData({...formData, actif: e.target.checked})}
                      className="w-4 h-4"
                    />
                    <label htmlFor="actif" className="text-sm font-medium">Actif</label>
                  </div>
                </div>

                <div className="flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      resetForm();
                    }}
                    className="px-4 py-2 border rounded hover:bg-gray-50"
                  >
                    Annuler
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                  >
                    {editMode ? 'Mettre à jour' : 'Créer'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GestionCategoriesTypes;
